import { INITIAL_PRODUCTS as initialProducts } from "../data/initialProducts";
import { INITIAL_WAREHOUSES as initialWarehouses } from "../data/initialWarehouses";
import { INITIAL_SUPPLIERS as initialSuppliers } from "../data/initialSuppliers";
import { INITIAL_CUSTOMERS as initialCustomers } from "../data/initialCustomers";
import { initialBatches } from "../data/initialBatches";
import {
  INITIAL_PURCHASE_ORDERS as initialPurchaseOrders,
  INITIAL_SALES_ORDERS as initialSalesOrders,
  initialStockTransfers,
  initialGRNs
} from "../data/initialOrders";
import { initialPayments, initialExpenses, initialReturnsAndDamages } from "../data/initialFinances";
import { INITIAL_EMPLOYEES as initialEmployees } from "../data/initialEmployees";
import { initialAuditLogs } from "../data/initialAuditLogs";

const STORAGE_KEYS = {
  PRODUCTS: "kirana_products_v2",
  WAREHOUSES: "kirana_warehouses_v2",
  SUPPLIERS: "kirana_suppliers_v2",
  CUSTOMERS: "kirana_customers_v2",
  BATCHES: "kirana_batches_v2",
  PURCHASE_ORDERS: "kirana_purchase_orders_v2",
  SALES_ORDERS: "kirana_sales_orders_v2",
  STOCK_TRANSFERS: "kirana_stock_transfers_v2",
  GRNS: "kirana_grns_v2",
  PAYMENTS: "kirana_payments_v2",
  EXPENSES: "kirana_expenses_v2",
  RETURNS: "kirana_returns_v2",
  EMPLOYEES: "kirana_employees_v2",
  AUDIT_LOGS: "kirana_audit_logs_v2"
};

function getStoredOrInitial(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (raw) return JSON.parse(raw);
  } catch (e) {
    console.warn(`Error loading key ${key} from storage`, e);
  }
  return fallback;
}

function saveToStorage(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {
    console.error(`Error saving key ${key} to storage`, e);
  }
}

// Simulated Latency
const delay = (ms = 350) => new Promise((resolve) => setTimeout(resolve, ms));

export const db = {
  products: getStoredOrInitial(STORAGE_KEYS.PRODUCTS, initialProducts),
  warehouses: getStoredOrInitial(STORAGE_KEYS.WAREHOUSES, initialWarehouses),
  suppliers: getStoredOrInitial(STORAGE_KEYS.SUPPLIERS, initialSuppliers),
  customers: getStoredOrInitial(STORAGE_KEYS.CUSTOMERS, initialCustomers),
  batches: getStoredOrInitial(STORAGE_KEYS.BATCHES, initialBatches),
  purchaseOrders: getStoredOrInitial(STORAGE_KEYS.PURCHASE_ORDERS, initialPurchaseOrders),
  salesOrders: getStoredOrInitial(STORAGE_KEYS.SALES_ORDERS, initialSalesOrders),
  stockTransfers: getStoredOrInitial(STORAGE_KEYS.STOCK_TRANSFERS, initialStockTransfers),
  grns: getStoredOrInitial(STORAGE_KEYS.GRNS, initialGRNs),
  payments: getStoredOrInitial(STORAGE_KEYS.PAYMENTS, initialPayments),
  expenses: getStoredOrInitial(STORAGE_KEYS.EXPENSES, initialExpenses),
  returns: getStoredOrInitial(STORAGE_KEYS.RETURNS, initialReturnsAndDamages),
  employees: getStoredOrInitial(STORAGE_KEYS.EMPLOYEES, initialEmployees),
  auditLogs: getStoredOrInitial(STORAGE_KEYS.AUDIT_LOGS, initialAuditLogs),

  persistAll() {
    saveToStorage(STORAGE_KEYS.PRODUCTS, this.products);
    saveToStorage(STORAGE_KEYS.WAREHOUSES, this.warehouses);
    saveToStorage(STORAGE_KEYS.SUPPLIERS, this.suppliers);
    saveToStorage(STORAGE_KEYS.CUSTOMERS, this.customers);
    saveToStorage(STORAGE_KEYS.BATCHES, this.batches);
    saveToStorage(STORAGE_KEYS.PURCHASE_ORDERS, this.purchaseOrders);
    saveToStorage(STORAGE_KEYS.SALES_ORDERS, this.salesOrders);
    saveToStorage(STORAGE_KEYS.STOCK_TRANSFERS, this.stockTransfers);
    saveToStorage(STORAGE_KEYS.GRNS, this.grns);
    saveToStorage(STORAGE_KEYS.PAYMENTS, this.payments);
    saveToStorage(STORAGE_KEYS.EXPENSES, this.expenses);
    saveToStorage(STORAGE_KEYS.RETURNS, this.returns);
    saveToStorage(STORAGE_KEYS.EMPLOYEES, this.employees);
    saveToStorage(STORAGE_KEYS.AUDIT_LOGS, this.auditLogs);
  },

  resetDefaults() {
    localStorage.clear();
    this.products = [...initialProducts];
    this.warehouses = [...initialWarehouses];
    this.suppliers = [...initialSuppliers];
    this.customers = [...initialCustomers];
    this.batches = [...initialBatches];
    this.purchaseOrders = [...initialPurchaseOrders];
    this.salesOrders = [...initialSalesOrders];
    this.stockTransfers = [...initialStockTransfers];
    this.grns = [...initialGRNs];
    this.payments = [...initialPayments];
    this.expenses = [...initialExpenses];
    this.returns = [...initialReturnsAndDamages];
    this.employees = [...initialEmployees];
    this.auditLogs = [...initialAuditLogs];
    this.persistAll();
  }
};

export { delay };
